<template>
    <div class="row">
        <div class="col-12 my-3">
            <div class="float-left f-12 align-items-center d-flex btn-group crmButonGroupsType">
                <button class="btn btn-click h40" @click="dealsStatus='all'" :class="{active:dealsStatus=='all'}">
                    {{$ml.get('ALL')}}
                </button>
                <button class="btn btn-click h40" @click="dealsStatus='open'" :class="{active:dealsStatus=='open'}">
                    {{$ml.get('OPEN')}}
                </button>
                <button class="btn btn-click h40 " @click="dealsStatus='won'" :class="{active:dealsStatus=='won'}">
                    {{$ml.get('WON')}}
                </button>
                <button class="btn btn-click h40" @click="dealsStatus='notwon'" :class="{active:dealsStatus=='notwon'}">
                    {{$ml.get('NOT_WON')}}
                </button>
            </div>
            <div class="float-right addBtn"  data-toggle="modal" data-target="#addDeal">
                <button type="button" class="btn bg-new-primary f-14 h-100">
                    <i class="fa fa-plus f-14 mr-2"></i> {{$ml.get('ADD_OPORTUNITY')}}
                </button>   
            </div>  
        </div>
        <div class="col-12 mb-3">
            <div class="bg-new-light border px-2 py-2 f-12 align-items-center d-flex deashBoard">
                <span class="mr-2" v-if="dealsStatus=='all'">
                    {{$ml.get('TOTAL_DEALS')}}: <b>{{getLenght(filterData)}}</b>
                </span>
                <span class="mr-2" v-if="dealsStatus=='all'">
                    {{$ml.get('TOTAL_AMMOUT')}}: <b>{{currencySymbol(defaultCurrency)}} {{formatPrice(allTotalPrice)}}</b>
                </span>
                <span class="mr-2" v-if="dealsStatus=='open'">
                    {{$ml.get('OPEN')}}: <b>{{openTotalCount}}</b>
                </span>
                <span class="mr-2" v-if="dealsStatus=='open' || dealsStatus=='all'">
                    {{$ml.get('OPEN')}}: <b>{{currencySymbol(defaultCurrency)}} {{formatPrice(openTotalPrice)}}</b>
                </span>
                <span class="mr-2" v-if="dealsStatus=='won'">
                    {{$ml.get('WON')}}: <b>{{wonTotalCount}}</b>
                </span>
                <span class="mr-2" v-if="dealsStatus=='won' || dealsStatus=='all'">
                    {{$ml.get('WON')}}: <b>{{currencySymbol(defaultCurrency)}} {{formatPrice(wonTotalPrice)}}</b>
                </span>
                <span class="mr-2" v-if="dealsStatus=='notwon'">
                    {{$ml.get('LOST')}}: <b>{{lostTotalCount}}</b>
                </span>
                <span v-if="dealsStatus=='notwon' || dealsStatus=='all'">
                    {{$ml.get('LOST')}}: <b>{{currencySymbol(defaultCurrency)}} {{formatPrice(notWonTotalPrice)}}</b>
                </span>
            </div>
        </div>
        <div class="col-12">
            <div class="row pl-3 pr-3">
                <div class="col-12 py-3 box-shadow border-radius-4 mb-3" v-for="i in filterData" @click="gotoCart(i._id.$oid)" :id="i._id.$oid">
                        
                        <div class="d-flex wrap-flex">
                            <div class="w-100 d-block pull-left">
                                <div>
                                    <span :class="statu(i)" class="dateInfo pull-left dealTag">{{statu(i, "getMessage", $ml, $ml.current)}}</span>
                                    <span v-if="i.status==2" class="win-btn border dealTag ml-1 dateInfo pull-left">{{$ml.get('WON')}}</span>
                                    <span v-else-if="i.status==3" class="notwin-btn border dealTag ml-1 dateInfo pull-left ">{{$ml.get('NOT_WON')}}</span>
                                    <span class="text-white ml-1 dateInfo pull-left dealTag" :class="getStageClass(i.stageId)" v-else>{{getStep(i.stageId, $ml)}}</span>
                                </div>
                                <span v-if="i.rate!==null" class="pull-right">
                                    <img src="~/../assets/rate-normal.png" v-if="i.rate==1" v-tooltip.left="getRates(i.rate)"/>
                                    <img src="~/../assets/rate-oncelikli.png" v-if="i.rate==2" v-tooltip.left="getRates(i.rate)"/>
                                    <img src="~/../assets/rate-acil.png" v-if="i.rate==3" v-tooltip.left="getRates(i.rate)"/>
                                </span>
                            </div>
                            <div class="w-100 d-block pull-left">
                                <p class="m-0 companyName" v-tooltip="organization.name">{{organization.name}} </p>
                            </div>
                            <div class="w-100 d-block pull-left">
                                <div class="f-12 bg-new-gray dealTitle pull-left dealTag">{{i.title}}</div>
                            </div>
                            <div class="w-100 d-block pull-left">
                                <label class="f-12 pb-0 mb-0 pull-left bg-new-gray dealTag">{{currencySymbol(i.currency)}} {{formatPrice(i.value)}}</label>
                                <span class="pull-left dealTag f-12 ml-1" v-if="i.notes!=undefined">
                                    <i class="fas fa-sticky-note" aria-hidden="true"></i>
                                    {{i.notes.length}}
                                </span>
                                <span v-if="i.cuid!==undefined && users.find(usr => usr._id['$oid']==i.cuid.$oid)!=null" class="pull-right bg-new-gray dealTag f-12 ml-1 cursor-pointer">
                                    {{users.find(usr => usr._id['$oid']==i.cuid.$oid).name}}<label v-if="i.cuid!==undefined" class="ml-1">{{users.find(usr => usr._id['$oid']==i.cuid.$oid).surName}}</label>
                                </span>
                            </div>
                        </div>
                </div>
            </div>
        </div>
        
    </div>
</template>

<script>
import axios from 'axios'
import {mapState} from 'vuex'
import {mapActions} from 'vuex'
export default {
    name: 'dealDetailPanel',
    components: {
    },
    data () {
        return {
            type:"save",
            dealsStatus:'all',
            allTotalPrice:0,
            wonTotalPrice:0,
            notWonTotalPrice:0,
            wonTotalCount:0,
            lostTotalCount:0,
            openTotalCount:0,
            openTotalPrice:0,
            isOpenDeal:false,
            deals:[],
            customFieldArray:[],
            defaultCurrency:localStorage.defaultCurrency
        }
    },
    props:["data","user","users","organization"],
    computed: {
        ...mapState([
            'baseUrl',
            'dealId'
        ]),
        filterData(){
            var status='all',allTotalPrice=0,wonTotalPrice=0,notWonTotalPrice=0,openTotalPrice=0,openTotalCount=0,wonTotalCount=0,lostTotalCount=0
            if(this.dealsStatus=='won'){
                status=2
            }
            else if(this.dealsStatus=='open'){
                status=1
            }
            if(this.dealsStatus=='notwon'){
                status=3
            }
            this.deals=[]
            for(var deal in this.data){
                
                allTotalPrice=allTotalPrice+this.data[deal].defaultValue
                if(this.data[deal].status==2){
                    wonTotalCount++
                    wonTotalPrice=wonTotalPrice+this.data[deal].defaultValue
                }else if(this.data[deal].status==3){
                    lostTotalCount++
                    notWonTotalPrice=notWonTotalPrice+this.data[deal].defaultValue
                }
                else if(this.data[deal].status==1){
                    openTotalCount++
                    openTotalPrice=openTotalPrice+this.data[deal].defaultValue
                }
                if(status=='all'){
                    this.deals.push(this.data[deal])
                }
                else if(this.data[deal].status==status){
                    this.deals.push(this.data[deal])
                }
            };
            this.allTotalPrice=allTotalPrice
            this.wonTotalPrice=wonTotalPrice
            this.notWonTotalPrice=notWonTotalPrice
            this.openTotalPrice=openTotalPrice
            this.openTotalCount=openTotalCount
            this.wonTotalCount = wonTotalCount
            this.lostTotalCount = lostTotalCount

            return this.deals
        },
    },
    methods:{
        changeCurrency(currencyId,value){
            if(currencyId==2){
                return value*this.trycurrencyUSD
            }else if(currencyId==3){
                return value*this.trycurrencyEUR
            }else{
                return value
            }
        },
        addDeal(deal){
            if(this.data==undefined){
                this.data.deals=[]
            }
            this.data.push(deal)
            this.isOpenDeal=true
        },
        gotoCart(id){
            this.updateDealId(id)
            localStorage.dealId=id
            window.open('/dealCard/'+id, '_blank');

        },
        getRates(rate){
        var rates={ 1:this.$ml.get('NORMAL'),2:this.$ml.get('PRIORITY'),3:this.$ml.get('URGENT') }
        return rates[rate]
        },
        ...mapActions([
            'updateDealId',
        ]),
        getStageClass(step){
            var className
            switch (step) {
            case 1:
                className="bg-new-blue"
                break;
            case 2:
                className="bg-new-primary"
                break;
            case 3:
                className="bg-new-secondry"
                break;
            case 4:
                className="bg-new-darkSecondry"
                break;
            default:
                className="bg-new-darkGray"
            }
            return className
        },
        getStep:function(step,ml){
            var stepId={1:ml.get('STEP_1'),2:ml.get('STEP_2'),3:ml.get('STEP_3'),4:ml.get('STEP_4'),5:ml.get('CONCLUDED')}
            return stepId[step]
        },
        getLenght: function(data){
            if(data!=undefined){
                return data.length
            }else{
                return 0
            }
        },
        statu: function (value,message,ml,langg) {
            if(value.expectedDate===undefined || value.expectedDate===null){
                if(message){
                    return ml.get('NO_ESTIMATED_CLOSING_DATE')
                }
                return "bg-date-not"
            }else{
                value=value.expectedDate.$date
                var dealDate=new Date(value)
                var date = new Date()
                var deal_day = dealDate.getDate();
                var deal_month = dealDate.getMonth();
                var deal_year = dealDate.getFullYear();
                var today = date.getDate();
                var this_month = date.getMonth();
                var this_year = date.getFullYear();
                var dealTime = new Date(deal_year,deal_month,deal_day);
                var currentTime = new Date(this_year,this_month,today);

                if(message){
                    if(dealTime<currentTime){
                        return ml.get('DATE_PASSED')
                    }else if(dealTime>currentTime){
                        var howDay = Math.round((dealTime - currentTime) / (1000 * 60 * 60 * 24))
                        if(langg!='tr'){
                            return "Closes in "+ howDay +" days "
                        }else{
                            return howDay+" gün sonra kapanacak"
                        }
                    }else{
                        return ml.get('CLOSED_TODAY')
                    }
                }else{
                    if(dealTime<currentTime){
                        return "bg-date-summary"
                    }else if(dealTime>currentTime){
                        var howDay = Math.round((dealTime - currentTime) / (1000 * 60 * 60 * 24))
                        if(howDay<=3){
                            return "bg-date-near-next"
                        }
                        return "bg-date-next"
                    }else{
                        return "bg-date-today-close"
                    }
                }
            }
        },
        formatPrice: function(val){
            if(val!==undefined){
                return val.toFixed(2).toString().replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1\,")
            }
        },
        getCustomField(){
            //if(this.active===false){
                axios({
                    method:'POST',
                    url:`/getCustomFields`,
                    baseURL: this.baseUrl,
                    data:{
                        domain:1
                    },
                    withCredentials:true
                }).then((res)=>{
                    return res
                }).then((res)=>{
                    if(res.data.status.code==0){
                        this.customFieldArray = res.data.content.customFields
                    }

                })
           // }

        }
    },
    created(){

        //this.getCustomField()
    },
    watch: {
        
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.win-btn{
    border-color: #36AF47 !important;
    color: #36AF47;
}
.notwin-btn{
    border-color: #EF4248 !important;
    color: #EF4248;
}
.dealCartStatus hr {
    border: 1px solid #66D0FF40!important;
    width: 100%!important;
}
.dealCartStatus .active {
    border: 1px solid #66D0FF!important;
}

@media (max-width: 992px) {
.deashBoard {
    flex-wrap: wrap;
}
.deashBoard>span
    {
        width: 50%;
        margin-right: 0 !important;
        margin-bottom:10px;
    }
}
</style>
